import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
import { useState } from "react";
import MarketingGeniusButton from "../EmpowerYourCareer/MarketingGeniusButton";
import FeaturedJobCard from "./FeaturedJobCard";

const calenderButtons = [
  { text: "01" },
  { text: "02" },
  { text: "03" },
  { text: "04" },
  { text: "05" },
];

function FeaturedJobsSection() {
  const [selectedDate, setSelectedDate] = useState(0);

  const { darkMode } = useDarkMode();
  return (
    <Stack sx={{ py: "50px", px: "70px" }}>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "end" }}
      >
        <Box>
          {" "}
          <Typography
            variant="body2"
            sx={{
              fontWeight: "700",
              fontSize: "54px",
              lineHeight: "74px",
              fontFamily: "Inter",
              color: darkMode ? "#ffffff" : "#0E0B33",
            }}
          >
            Featured Jobs
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "30px",
              fontFamily: "Inter",
              color: darkMode ? "#8d8d8d" : "#878599",
              maxWidth: "465px",
              pt: "4px",
            }}
          >
            Our current top picks for your dream career based on our current
            popular listing.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "42px",
            pb: "14px",
          }}
        >
          {calenderButtons.map((btn, i) => {
            const activeDate = i === selectedDate;
            return (
              <Button
                variant="contained"
                sx={{
                  p: activeDate ? "4px" : "0px",
                  px: activeDate ? "10px" : "0px",
                  borderRadius: "10px",
                  minWidth: "auto",
                  width: "auto",
                  textTransform: "none",
                  bgcolor: activeDate
                    ? `${darkMode ? "#333022" : "#e5e5e5"}`
                    : `${darkMode ? "transparent" : "#ffffff"}`,
                  color: activeDate
                    ? `${darkMode ? "#FDDF59" : "#0E0B33"}`
                    : `${darkMode ? "#ffffff" : "#0E0B33"}`,
                  boxShadow: "none",
                  fontWeight: "700",
                  fontSize: "20px",
                  lineHeight: "30px",
                  fontFamily: "Inter",
                  "&:hover": {
                    backgroundColor: activeDate
                      ? `${darkMode ? "#333022" : "#e5e5e5"}`
                      : "transparent",
                    boxShadow: "none",
                  },
                  "&:active": {
                    backgroundColor: `${darkMode ? "#333022" : "#e5e5e5"}`,
                    boxShadow: "none",
                  },
                }}
                onClick={() => setSelectedDate(i)}
              >
                {btn.text}
              </Button>
            );
          })}
        </Box>
      </Stack>
      <Stack
        direction="row"
        sx={{
          px: "28px",
          justifyContent: "space-between",
          pt: "44px",
          alignItems: "start",
          gap: "20px",
        }}
      >
        <FeaturedJobCard shadow={true} />
        <Box sx={{ pt: "40px" }}>
          <FeaturedJobCard />
        </Box>
      </Stack>
    </Stack>
  );
}

export default FeaturedJobsSection;
